import qs from 'qs';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { getMultUrl } from '@tencent/tencent_doc_open_url';

/**
 * default features for `window.open`
 * check https://html.spec.whatwg.org/multipage/window-object.html#concept-window-open-features-tokenize
 */
const defaultWindowFeatures = {
    directories: 0,
    location: 0,
    statusbar: 0,
    toolbar: 0,
    resizable: 1,
    menubar: 0,
    scrollbars: 0,

    top: 0,
    left: 0,

    width: 800,
    height: 520,
};

type WindowFeatures = typeof defaultWindowFeatures;
type PopupWindowFeatures = Pick<WindowFeatures, 'left' | 'top' | 'width' | 'height'>;

/**
 * 打开弹出式窗口
 * 1. url 多账号处理; (@tencent/tencent_doc_open_url 提供的 `tencentDocOpenUrl` 方法拿不到 window 对象)
 * 2. features 类型改为对象, 固定大部分配置，只允许修改 'left' | 'top' | 'width' | 'height'
 *   - 注：浏览器会依据 features 决定是否以 Popup 形式打开窗口，详见 https://html.spec.whatwg.org/multipage/window-object.html#popup-window-is-requested
 */
export const openPopupWindow = (
    url: string,
    windowName: string,
    popupWindowFeatures: Partial<PopupWindowFeatures>,
): Window | null => {
    const mulUrl = getMultUrl(url);
    const features = {
        ...defaultWindowFeatures,
        ...popupWindowFeatures,
    };

    const featuresStr = qs.stringify(features, { delimiter: ',' });
    const popupWindow = window.open(mulUrl, windowName, featuresStr);

    return popupWindow;
};

export const focusPopupWindow = (popUpWindow: Window, windowName: string): void => {
    if (browser.isTencentDocDesktopApp) {
        window.mqq.invoke('docx', 'focusChildWindow', { frameName: windowName });
    } else {
        popUpWindow.focus();
    }
};
